import { ButtonLinkProps } from '@vk-cloud-solutions/marketing-ui';

import { NextImageProps } from '~components/NextImage/NextImage.types';
import { ContentBlockWrapperProps } from '~containers/ArticlePage/ContentBlockWrapper/ContentBlockWrapper.types';
import { ArticlePageBlockComponent } from '~types/BlockComponent.types';

export enum ImagePosition {
  Left = 'Left',
  Right = 'Right',
}

export type ContentBlockBannerProps = ContentBlockWrapperProps & {
  component: ArticlePageBlockComponent.SectionBanner;
  title: string;
  text: string;
  button?: ButtonLinkProps;
  image?: NextImageProps;
  imagePosition: ImagePosition;
  titleMenu?: string;
};
